
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0e5bd21c&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SamplingFragment.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SamplingFragment.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0e5bd21c!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SamplingFragment.vue"),
  /* scopeId */
  "data-v-0e5bd21c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/activity/SamplingFragment.vue
// module id = 386
// module chunks = 2